<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/internal-control')" style="cursor: pointer">Control Interno</li>
        <li class="breadcrumb-item active" aria-current="page">Requerimientos del Panel de Cumplimiento</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card style="overflow-x: auto;">
            <md-card-header>
              <div class="md-title">Requerimientos
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="addRequirement">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>ID</md-table-head>
                  <md-table-head>Orden</md-table-head>
                  <md-table-head>Requerimiento</md-table-head>
                  <md-table-head>Código</md-table-head>
                  <md-table-head>Descripción</md-table-head>
                  <md-table-head>Texto del Botón</md-table-head>
                  <md-table-head>Tags</md-table-head>
                  <md-table-head>Fecha de Obligación</md-table-head>
                  <md-table-head>Editar</md-table-head>
                  <md-table-head>Eliminar</md-table-head>
                </md-table-row>
                <md-table-row v-for="req in requirements" :key="req.id">
                  <md-table-cell>{{req.id}}</md-table-cell>
                  <md-table-cell>{{req.button_order}}</md-table-cell>
                  <md-table-cell>{{req.requirement}}</md-table-cell>
                  <md-table-cell>{{req.code}}</md-table-cell>
                  <md-table-cell>{{req.description}}</md-table-cell>
                  <md-table-cell>{{req.button_text}}</md-table-cell>
                  <md-table-cell>
                    <vs-list v-for="tag in req.mandatory_tags" :key="tag.id">
                        <vs-list-item :title="tag.tag" :subtitle="tag.compliance_link"></vs-list-item>
                    </vs-list>
                  </md-table-cell>
                  <md-table-cell>{{req.mandatory_date | human_date}}</md-table-cell>
                  <md-table-cell>
                      <vs-button radius color="primary" icon-pack="feather" icon="icon-edit" @click="editarReq(req)"></vs-button>
                  </md-table-cell>
                  <md-table-cell>
                      <vs-button radius color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteEvent(req.id)"></vs-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <!-- MODAL PARA REGISTRAR O ACTUALIZAR REQUERIMIENTO -->
    <div class="modal fade" id="modal_new_requirement" tabindex="-1" role="dialog" aria-labelledby="modal_new_requirement_label" aria-hidden="true">
        <div class="modal-dialog modal-reports modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="modal_new_event_label">{{titleModal}}</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="vx-row mb-6">
                      <div class="vx-col md:w-1/2 w-full">
                        <vs-input class="w-full" label="Requerimiento" v-model="currentRequirement.requirement" />
                      </div>
                      <div class="vx-col md:w-1/2 w-full">
                        <label for class="vs-input--label">Fecha de obligación:</label>
                          <datepicker
                            placeholder="Selecciona"
                            :language="es"
                            v-model="currentRequirement.mandatory_date"
                            format="dd/MM/yyyy"
                          />
                      </div>
                    </div>
                    <div class="vx-row mb-6">
                      <div class="vx-col md:w-1/3 w-full">
                        <vs-input class="w-full" label="Código" v-model="currentRequirement.code" />
                      </div>
                      <div class="vx-col md:w-1/3 w-full">
                        <vs-input class="w-full" label="Texto del botón" v-model="currentRequirement.button_text" />
                      </div>
                      <div class="vx-col md:w-1/3 w-full">
                        <vs-input type="number" class="w-full" label="Orden" v-model="currentRequirement.button_order" />
                      </div>
                    </div>
                    <div class="vx-row mb-6">
                      <div class="vx-col w-full">
                        <vs-input class="w-full" label="Descripción" v-model="currentRequirement.description" />
                      </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="col-xs-12 col-md-7">
                          <h5>Agregar nuevo tag:</h5>
                          <div class="vx-row mt-4">
                            <div class="vx-col col-md-6 w-full">
                              <vs-input class="w-full" label="Tag" v-model="newTag.tag" />
                            </div>
                            <div class="vx-col col-md-6 w-full">
                              <vs-input class="w-full" label="Link" v-model="newTag.compliance_link" />
                            </div>
                          </div>
                          <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                              <vs-textarea label="Texto que aparecerá en el panel para este tag..." v-model="newTag.panel_text" />
                              <vs-button color="dark" class="mt-1" @click="addTag()">Agregar tag</vs-button>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-12 col-md-5">
                          <h5>Tags registrados ({{currentRequirement.mandatory_tags.length}}):</h5>
                          <vs-list v-for="(tag,index) in currentRequirement.mandatory_tags" v-bind:key="index">
                            <vx-tooltip :text="tag.panel_text? tag.panel_text:'Texto default para el panel'">
                              <vs-list-item :title="tag.tag" :subtitle="tag.compliance_link"><vs-button radius color="danger" icon-pack="feather" icon="icon-trash" @click="deleteTag(tag)"></vs-button></vs-list-item>
                            </vx-tooltip>
                          </vs-list>
                        </div>
                    </div>
                    <div class="skinny row">
                        <div class="col-md-12">
                            <div class="flex flex-wrap">
                                <vs-button color="success" :disabled="!canSaveReq" @click="guardarReq()">Guardar requerimiento</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

  </div>

</template>

<script lang="js">
  import * as moment from "moment";
  import Datepicker from "vuejs-datepicker";
  import { es } from "vuejs-datepicker/dist/locale";

  export default  {
    name: 'compliance-requirement',
    components: {
      Datepicker,
    },
    filters: {
      human_date(date) {
        return date == null ? '' : moment(date).lang("es").format("DD MMM YYYY");
      }
    },
    mounted() {
      this.getRequirements();
    },
    data() {
      return {
        es: es,
        titleModal: "Nuevo requerimiento",
        newTag: {
          tag: null,
          compliance_link: null,
          panel_text: null
        },
        currentRequirement: {
            id:-1,
            code:"",
            requirement:"",
            description:"",
            button_text:"",
            button_order:"",
            mandatory_date:"",
            mandatory_tags:[]
        },
        requirements: [],
        reqIdToDelete:-1,
      }
    },
    computed: {
        canSaveReq() {
          let req = this.currentRequirement;
          return (req.code && req.requirement && req.button_text && req.button_order && req.mandatory_date);
        }
    },
    methods: {
      addRequirement(){
        this.titleModal = "Nuevo requerimiento";
        this.limpiar(); 
        $('#modal_new_requirement').modal('show');
      },
      addTag(){
        if (!this.newTag.tag && !this.newTag.compliance_link) {
          this.errorNotif("Aviso", 'Debes ingresar ambos campos del Tag.', 4000);
          return;
        }
        let tag = {
          "tag": this.newTag.tag,
          "compliance_link": this.newTag.compliance_link,
          "panel_text": this.newTag.panel_text,
        }
        this.currentRequirement.mandatory_tags.push(tag);
        this.newTag.tag = null;
        this.newTag.compliance_link = null;
        this.newTag.panel_text = null;
      },
      deleteTag(tag){
        this.currentRequirement.mandatory_tags.splice(this.currentRequirement.mandatory_tags.indexOf(tag), 1);
      },
      limpiar(){
        this.currentRequirement.id = -1;
        this.currentRequirement.code="";
        this.currentRequirement.requirement="";
        this.currentRequirement.description="";
        this.currentRequirement.button_text="";
        this.currentRequirement.button_order="";
        this.currentRequirement.mandatory_date="";
        this.currentRequirement.mandatory_tags=[];
      },
      getRequirements(){
        this.showLoading(true);
        axios.get( '/api/catalogs/compliance_requirements').then(response => {
          this.requirements = response.data.data;
          this.requirements.forEach(req => {
            if (!req.mandatory_tags) {
              req.mandatory_tags = [];
            }
          });
          this.showLoading(false);
        });
      },
      guardarReq(){
        // const found = this.requirements.find(req => (req.button_order == this.currentRequirement.button_order && req.id != this.currentRequirement.id ));
        // if (found) {
        //   this.errorNotif("Aviso", 'No puede haber mas de un requerimiento con el mismo orden '+"("+this.currentRequirement.button_order+")", 4000);
        //   return;
        // }
        this.showLoading(true);
        axios.post( '/api/catalogs/compliance_requirements/save', {
          'compliance_requirement_id': this.currentRequirement.id,
          'code': this.currentRequirement.code,
          'requirement': this.currentRequirement.requirement,
          'description': this.currentRequirement.description,
          'button_text': this.currentRequirement.button_text,
          'button_order': this.currentRequirement.button_order,
          'mandatory_date': this.format_date(this.currentRequirement.mandatory_date),
          'mandatory_tags': this.currentRequirement.mandatory_tags
        }).then(response => {
          this.limpiar();
          this.showLoading(false);
          this.getRequirements();
          this.successNotif("Aviso", 'Requerimiento guardado correctamente', 4000);
        }).catch(error => {
          this.showLoading(false);
          this.errorNotif("Aviso", 'Ha ocurrido un error', 4000);
        });
      },
      editarReq(req){
        this.currentRequirement.id = req.id;
        this.currentRequirement.code=req.code;
        this.currentRequirement.requirement=req.requirement;
        this.currentRequirement.description=req.description;
        this.currentRequirement.button_text=req.button_text;
        this.currentRequirement.button_order=req.button_order;
        this.currentRequirement.mandatory_date=this.format_date(req.mandatory_date);
        this.currentRequirement.mandatory_tags=req.mandatory_tags.slice();
        this.titleModal = "Editar requerimiento";
        $('#modal_new_requirement').modal('show');
      },
      confirmDeleteEvent(id){
          this.reqIdToDelete = id;
          this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Aviso`,
              text: '¿Estas seguro de querer eliminar el requerimiento?',
              acceptText: "Confirmar",
              cancelText: "Cancelar",
              accept: this.deleteReq
          })
      },
      deleteReq(rid){
        this.showLoading(true);
        axios.post( '/api/catalogs/compliance_requirements/delete', {
          'compliance_requirement_id':  this.reqIdToDelete,
        }).then(response => {
          this.getRequirements();
          this.showLoading(false);
          this.successNotif("Aviso", 'Requerimiento borrado correctamente', 4000);
        }).catch(error => {
          this.showLoading(false);
          this.errorNotif("Aviso", 'Ha ocurrido un error', 4000);
        });
      },
      format_date(fecha){
        fecha = new Date(fecha);
        if(fecha.getMonth()+1<10 && fecha.getDate()<10)
          return fecha.getFullYear()+'-0'+(fecha.getMonth()+1)+'-0'+fecha.getDate();
        if(fecha.getMonth()+1<10)
          return fecha.getFullYear()+'-0'+(fecha.getMonth()+1)+'-'+fecha.getDate();
        if(fecha.getDate()<10)
          return fecha.getFullYear()+'-'+(fecha.getMonth()+1)+'-0'+fecha.getDate();
        return fecha.getFullYear()+'-'+(fecha.getMonth()+1)+'-'+fecha.getDate();
      },
    },
}
</script>

<style scoped>
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    margin-left: 30%;
    border-radius: 30px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: rgb(243, 205, 33);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>
